import "core-js/modules/es.array.filter.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SearchForm from '@/components/SearchForm';
import addDate from '@/components/System/dictionary/addDate.vue';
import addDict from '@/components/System/dictionary/addDict.vue';
import editorDict from '@/components/System/dictionary/editordict.vue';
import addRelation from '@/components/System/dictionary/addRelation.vue';
import NoData from '@/components/NoData/NoData';
import { valsubstr32addbr } from '@/utils';
import { getSystemInnerList } from '@/api/message';
export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    SearchForm: SearchForm,
    addDate: addDate,
    addDict: addDict,
    editorDict: editorDict,
    // eslint-disable-next-line vue/no-unused-components
    addRelation: addRelation,
    NoData: NoData
  },
  data: function data() {
    return {
      btnType: 'search',
      dictKey: '',
      selectData: [],
      selectedval: [],
      defaultProps: {
        children: 'children',
        label: 'dictGroupName'
      },
      data: [{
        dictGroupName: '键值对分组',
        id: '',
        onlyid: 'Dicttotle',
        children: [{
          dictGroupName: '键值对组',
          id: '',
          onlyid: 'Dictreal',
          children: []
        }, {
          dictGroupName: '键值对组（虚拟）',
          id: '',
          onlyid: 'Dictviral',
          children: []
        }]
      }],
      tableData: [],
      currentTable: {},
      selectsystem: null,
      dictObj: {},
      dictGroupObj: {
        subType: 'add'
      },
      tableJson: [
      // { prop: "systemName", label: "子系统", minWidth: "100" },
      {
        prop: 'dictCode',
        label: '键值对键',
        minWidth: '100'
      }, {
        prop: 'dictName',
        label: '键值对名称',
        minWidth: '100'
      }, {
        prop: 'dictGroupName',
        label: '键值对组',
        minWidth: '100'
      },
      // { prop: "dictOrder", label: "排序", minWidth: "100" },
      {
        prop: 'dictStatus',
        label: '状态',
        minWidth: '100'
      }],
      pagination: {
        pageNum: 1,
        pageSize: 10,
        param: {
          groupId: '',
          dictName: '',
          systemId: ''
        }
      },
      searchRelationdata: {
        orderBy: 'created_time desc',
        pageNum: 1,
        pageSize: 999,
        param: {
          realGroupName: '',
          systemId: '3',
          virtualGroupId: 30
        }
      },
      Relationlist: [],
      iseditdic: false,
      iseditVirtualdic: false,
      isedit: false,
      loading: false,
      isVirtual: false,
      pageshow: true,
      // showDictandVirtual:false,
      total: 0,
      currentNode: {},
      showAddDate: false,
      showAddDictGroup: false,
      showeditorDictGroup: false,
      tableheight: 0,
      selectnode: ''
    };
  },
  created: function created() {
    // this.getSystemList(this.getDictList);
    this.getsystemlist();
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.tableheight = window.innerHeight - 350;
      // 监听窗口大小变化
      var self = this;
      window.onresize = function () {
        self.tableheight = window.innerHeight - 350;
      };
    });
  },
  methods: {
    searchForm: function searchForm() {
      this.isVirtual = false;
      this.pagination = {
        pageNum: 1,
        pageSize: 10,
        param: {
          groupId: this.currentNode.id || '',
          dictName: this.dictKey,
          systemId: this.selectedval
        }
      };
    },
    resetSearchForm: function resetSearchForm() {
      this.getsystemlist();
      this.dictKey = '';
      this.pagination.param.dictName = '';
    },
    getsystemlist: function getsystemlist() {
      var _this = this;
      getSystemInnerList().then(function (res) {
        var code = res.code,
          result = res.result;
        if (code === '0000000000') {
          _this.selectData = result.records;
          _this.selectedval = result.records[0].systemId;
          _this.pagination.param.systemId = _this.selectedval;
          _this.getDictAndVirtualGroup();
          // this.getDictList();
        }
      });
    },
    getsearchRelation: function getsearchRelation() {
      var _this2 = this;
      this.$API.postRequest({
        url: '/platform/virtualDict/searchRelation',
        data: this.searchRelationdata
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this2.Relationlist = res.result.list;
        }
      });
    },
    // 改变每页显示数
    handleSizeChange: function handleSizeChange(val) {
      this.pagination.pageSize = val;
    },
    // 改变页码
    handleCurrentChange: function handleCurrentChange(val) {
      this.pagination.pageNum = val;
    },
    clickDep: function clickDep(e) {
      if (e.isVirtual) {
        this.isVirtual = true;
      } else {
        this.isVirtual = false;
      }
      this.currentNode = e;
      if (!e.children) {
        // this.currentNode = e;
        this.$refs.dictTree.setCurrentKey(e.onlyid);
        this.pagination = {
          pageSize: 10,
          pageNum: 1,
          param: {
            groupId: e.id,
            dictName: '',
            systemId: this.selectedval
          }
        };
      }
    },
    renderContent: function renderContent(h, _ref) {
      var node = _ref.node,
        data = _ref.data;
      var that = this;
      if (data.children) {
        if (data.dictGroupName === '键值对分组') {
          return h("span", {
            "class": "tree-node wrap-tree-node"
          }, [h("span", [node.label])]);
        } else {
          return h("span", {
            "class": "tree-node wrap-tree-node"
          }, [h("span", [node.label]), h("el-tooltip", {
            "class": "item",
            "attrs": {
              "effect": "dark",
              "content": "添加键值对组",
              "placement": "top-start"
            }
          }, [h("span", [h("i", {
            "directives": [{
              name: "show",
              value: this.currentNode.onlyid === data.onlyid
            }],
            "class": "el-icon-plus",
            "on": {
              "click": function click(e) {
                if (that.selectedval.length === 0) {
                  return that.$message({
                    message: '请先选择子系统',
                    type: 'warning'
                  });
                }
                if (data.dictGroupName === '键值对组') {
                  that.isVirtual = false;
                  that.showAddDictGroup = true;
                  that.iseditdic = false;
                } else {
                  that.isVirtual = true;
                  that.showeditorDictGroup = true;
                  that.iseditVirtualdic = false;
                }
                that.dictGroupObj = {
                  systemId: that.selectedval,
                  subType: 'add',
                  selectData: that.selectData
                };
                e.stopImmediatePropagation();
              }
            }
          })])])]);
        }
      } else {
        if (data.isVirtual) {
          return h("span", {
            "class": "tree-node wrap-tree-node"
          }, [h("el-tooltip", {
            "class": "item",
            "attrs": {
              "effect": "dark",
              "placement": "top"
            }
          }, [h("div", {
            "domProps": {
              "innerHTML": this.ToBreak(node.label)
            },
            "slot": "content"
          }), h("span", {
            "class": "tree-node namelaber"
          }, [node.label])]), h("el-tooltip", {
            "class": "item",
            "attrs": {
              "effect": "dark",
              "content": "修改键值对",
              "placement": "top-start"
            }
          }, [h("span", [h("i", {
            "directives": [{
              name: "show",
              value: this.currentNode.onlyid === data.onlyid
            }],
            "class": "el-icon-edit-outline",
            "on": {
              "click": function click(e) {
                that.dictGroupObj = {
                  systemId: that.selectedval,
                  dictGroupCode: data.dictGroupCode,
                  dictGroupName: data.dictGroupName,
                  subType: 'edit',
                  selectData: that.selectData,
                  id: data.id
                };
                that.currentNode = JSON.parse(JSON.stringify(data));
                that.searchRelationdata.param.virtualGroupId = data.id;
                that.searchRelationdata.param.systemId = that.selectedval;
                if (data.isVirtual) {
                  that.isVirtual = true;
                  that.getsearchRelation();
                  that.showeditorDictGroup = true;
                  that.iseditVirtualdic = true;
                } else {
                  that.isVirtual = false;
                  that.showAddDictGroup = true;
                  that.iseditdic = true;
                }
                // console.log(data.relations,"llisdljasdlasjkl")
                // that.showeditorDictGroup = true;
                e.stopImmediatePropagation();
              }
            }
          })])])]);
        } else {
          return h("span", {
            "class": "tree-node wrap-tree-node"
          }, [h("el-tooltip", {
            "class": "item",
            "attrs": {
              "effect": "dark",
              "placement": "top"
            }
          }, [h("div", {
            "domProps": {
              "innerHTML": this.ToBreak(node.label)
            },
            "slot": "content"
          }), h("span", {
            "class": "tree-node namelaber"
          }, [node.label])]), h("span", [h("el-tooltip", {
            "class": "item",
            "attrs": {
              "effect": "dark",
              "content": "添加键值对",
              "placement": "top-start"
            }
          }, [h("i", {
            "directives": [{
              name: "show",
              value: this.currentNode.onlyid === data.onlyid
            }],
            "class": "el-icon-plus",
            "on": {
              "click": function click(e) {
                if (that.selectedval.length === 0) {
                  return that.$message({
                    message: '请先选择子系统',
                    type: 'warning'
                  });
                }
                that.currentNode = JSON.parse(JSON.stringify(data));
                that.dictGroupObj = {
                  systemId: that.selectedval,
                  subType: 'add',
                  selectData: that.selectData
                };
                e.stopImmediatePropagation();
                if (data.isVirtual) {
                  // that.showDictandVirtual = true;
                } else {
                  // 添加外层键值对，传true
                  that.addDateFn(true);
                }
              }
            }
          })]), h("el-tooltip", {
            "class": "item",
            "attrs": {
              "effect": "dark",
              "content": "修改键值对",
              "placement": "top-start"
            }
          }, [h("i", {
            "directives": [{
              name: "show",
              value: this.currentNode.onlyid === data.onlyid
            }],
            "class": "el-icon-edit-outline",
            "on": {
              "click": function click(e) {
                that.dictGroupObj = {
                  systemId: that.selectedval,
                  dictGroupCode: data.dictGroupCode,
                  dictGroupName: data.dictGroupName,
                  subType: 'edit',
                  selectData: that.selectData,
                  id: data.id
                };
                that.currentNode = JSON.parse(JSON.stringify(data));
                that.searchRelationdata.param.virtualGroupId = data.id;
                that.searchRelationdata.param.systemId = that.selectedval;
                if (data.isVirtual) {
                  that.isVirtual = true;
                  that.getsearchRelation();
                  that.showeditorDictGroup = true;
                  that.iseditVirtualdic = true;
                } else {
                  that.isVirtual = false;
                  that.showAddDictGroup = true;
                  that.iseditdic = true;
                }
                // console.log(data.relations,"llisdljasdlasjkl")
                // that.showeditorDictGroup = true;
                e.stopImmediatePropagation();
              }
            }
          })])])]);
        }
      }
    },
    editRoleDialog: function editRoleDialog(item) {
      this.$refs["datadict-".concat(item.row.id)].doClose();
      this.isedit = true;
      this.currentTable = item.row;
      this.editDateFn();
    },
    adddictFn: function adddictFn(item) {
      this.currentTable = item.row;
      // 添加内部键值对，传false
      this.$refs["datadict-".concat(item.row.id)].doClose();
      this.addDateFn(false);
    },
    changeSystemId: function changeSystemId() {
      // this.getDictGroupList();
      this.getDictAndVirtualGroup();
      // this.pagination = {
      //   pageSize: 10,
      //   pageNum: 1,
      //   param: {
      //     groupId: "",
      //     dictName: this.dictKey,
      //     systemId: this.selectedval,
      //   },
      // };
    },
    handleSelectionChange: function handleSelectionChange(e) {
      this.currentTable = e;
    },
    addDateFn: function addDateFn(bool) {
      // if (!this.currentNode.dictGroupCode) {
      //   return this.$message({ type: "warning", message: "请选择分组" });
      // }
      this.isedit = false;
      if (bool) {
        this.dictObj = {
          selectData: this.selectData,
          systemId: this.selectedval,
          dictGroupCode: this.currentNode.dictGroupCode,
          groupId: this.currentNode.id,
          subType: 'add'
        };
      } else {
        this.dictObj = {
          selectData: this.selectData,
          systemId: this.selectedval,
          dictGroupCode: this.currentTable.dictGroupCode,
          groupId: this.currentTable.groupId,
          parentId: this.currentTable.id,
          subType: 'addchild'
        };
      }
      this.showAddDate = true;
    },
    editDateFn: function editDateFn() {
      if (this.currentTable) {
        this.dictObj = {
          selectData: this.selectData,
          systemId: this.selectedval,
          dictGroupCode: this.currentTable.dictGroupCode,
          dictName: this.currentTable.dictName,
          dictCode: this.currentTable.dictCode,
          dictOrder: this.currentTable.dictOrder,
          groupId: this.currentTable.groupId,
          dictStatus: this.currentTable.dictStatus,
          parentId: this.currentTable.parentId,
          id: this.currentTable.id,
          subType: 'edit'
        };
        this.showAddDate = true;
      } else {
        this.$message({
          type: 'warning',
          message: '请先选择键值对'
        });
      }
    },
    deleteDateFn: function deleteDateFn() {
      var _this3 = this;
      if (this.currentTable) {
        this.$API.getRequest({
          url: "/platform/virtualDict/deleteRelation/".concat(this.currentTable.id)
        }).then(function () {
          _this3.getDictList();
        });
      } else {
        this.$message({
          type: 'warning',
          message: '请先选择键值对'
        });
      }
    },
    getDictGroupList: function getDictGroupList() {
      this.$API.getRequest({
        url: "/platform/dict/searchDictGroup/".concat(this.selectedval)
      }).then(function () {
        // this.data[0].children = res.result;
        // this.$nextTick(() => {
        //   this.currentNode = {};
        //   this.$refs.dictTree.setCurrentKey(null);
        // });
      });
    },
    getDictAndVirtualGroup: function getDictAndVirtualGroup() {
      var _this4 = this;
      this.$API.getRequest({
        url: "/platform/dict/searchDictAndVirtualGroup/".concat(this.selectedval)
      }).then(function (res) {
        _this4.data[0].children[0].children = res.result[1].value;
        _this4.data[0].children[1].children = res.result[0].value;
        //  console.log(res.result[0].value,"this.datathis.datathis.data");
        // eslint-disable-next-line array-callback-return
        _this4.data[0].children[0].children.filter(function (item) {
          item.onlyid = "".concat(item.id, "v");
        });
        // eslint-disable-next-line array-callback-return
        _this4.data[0].children[1].children.filter(function (item) {
          item.onlyid = "".concat(item.id, "t");
        });
        _this4.$nextTick(function () {
          _this4.currentNode = {};
          // this.$refs.dictTree.setCurrentKey(null);
        });
        // this.data[0].children = res.result;
        // this.$nextTick(() => {
        //   this.currentNode = {};
        //   this.$refs.dictTree.setCurrentKey(null);
        // });
      });
    },
    getDictList: function getDictList() {
      var _this5 = this;
      this.loading = true;
      this.$API.postRequest({
        url: '/platform/dict/searDictDetail',
        data: this.pagination
      }).then(function (res) {
        _this5.loading = false;
        if (res.code === '0000000000') {
          _this5.total = res.result.total;
          _this5.tableData = res.result.records;
        }
      });
    },
    getvirtualdictlist: function getvirtualdictlist() {
      var _this6 = this;
      this.loading = true;
      this.$API.getRequest({
        url: "/platform/virtualDict/queryVirtualDictDetail/".concat(this.currentNode.id),
        data: {
          pageNum: this.pagination.pageNum,
          pageSize: this.pagination.pageSize,
          virtualGroupId: this.currentNode.id
        }
      }).then(function (res) {
        _this6.loading = false;
        if (res.code === '0000000000') {
          _this6.total = res.result.total;
          _this6.tableData = res.result.list;
        }
      });
    },
    // 添加键值对组
    DictgroupAddSubmitfn: function DictgroupAddSubmitfn(obj) {
      var _this7 = this;
      this.showAddDictGroup = false;
      if (obj.bool) {
        obj.formData.systemId = this.selectedval;
        if (this.iseditdic) {
          obj.formData.id = this.currentNode.id;
          this.$API.postRequest({
            url: '/platform/dict/updateDictGroup/',
            data: obj.formData
          }).then(function (res) {
            if (res.code === '0000000000') {
              _this7.$message({
                message: '更新键值对组成功',
                type: 'success'
              });
              _this7.getDictAndVirtualGroup();
            }
          });
        } else {
          this.$API.postRequest({
            url: '/platform/dict/addDictGroup/',
            data: obj.formData
          }).then(function (res) {
            if (res.code === '0000000000') {
              _this7.$message({
                message: '添加键值对组成功',
                type: 'success'
              });
              _this7.getDictAndVirtualGroup();
            }
          });
        }
      }
    },
    DictgroupeditorSubmitfn: function DictgroupeditorSubmitfn(obj) {
      var _this8 = this;
      this.showeditorDictGroup = false;
      if (obj.bool) {
        obj.formData.systemId = this.selectedval;
        if (this.iseditVirtualdic) {
          obj.formData.id = this.searchRelationdata.param.virtualGroupId;
          // eslint-disable-next-line array-callback-return
          obj.formData.relations.filter(function (item, i) {
            obj.formData.relations[i] = {
              realGroupId: item,
              virtualGroupId: _this8.searchRelationdata.param.virtualGroupId
            };
          });
          this.$API.postRequest({
            url: '/platform/virtualDict/updateVirtualDict/',
            data: obj.formData
          }).then(function (res) {
            if (res.code === '0000000000') {
              _this8.$message({
                message: '更新键值对组(虚拟)成功',
                type: 'success'
              });
              _this8.getDictAndVirtualGroup();
            }
          });
        } else {
          // eslint-disable-next-line array-callback-return
          obj.formData.relations.filter(function (item, i) {
            obj.formData.relations[i] = {
              realGroupId: item
            };
          });
          this.$API.postRequest({
            url: '/platform/virtualDict/addVirtualDict/',
            data: obj.formData
          }).then(function (res) {
            if (res.code === '0000000000') {
              _this8.$message({
                message: '添加键值对组成功',
                type: 'success'
              });
              _this8.getDictAndVirtualGroup();
            }
          });
        }
      }
    },
    close: function close(key) {
      var _this9 = this;
      this[key.showAddDate] = false;
      if (key.subType === 'add') {
        this.pageshow = false;
        this.pagination.pageNum = this.total % this.pagination.pageSize === 0 ? Math.ceil(this.total / this.pagination.pageSize) + 1 : Math.ceil(this.total / this.pagination.pageSize);
        this.$nextTick(function () {
          _this9.pageshow = true;
        });
      }
    },
    // tooltips过长换行(length 32换行)
    ToBreak: function ToBreak(val) {
      if (val) {
        return valsubstr32addbr(val);
      }
    },
    handleNodeExpandorcollapse: function handleNodeExpandorcollapse(data) {
      this.$refs.dictTree.setCurrentKey(data.onlyid);
    },
    // 拖动表头改变大小
    headerdragend: function headerdragend(newWidth, oldWidth, column) {
      if (newWidth < column.minWidth) {
        column.width = column.minWidth;
      }
    }
  },
  watch: {
    pagination: {
      handler: function handler() {
        if (this.isVirtual) {
          this.getvirtualdictlist();
        } else {
          this.getDictList();
        }
      },
      deep: true
    }
  }
};